class TabCollection {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.tab-collection__tab');
    this.panels = container.querySelectorAll('.tab-collection__panel');

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
    });
  }

  switchTab(newIndex) {
    // Remove active class from all tabs and panels
    this.tabs.forEach((tab) => {
      tab.classList.remove('tab-collection__tab--active');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('tab-collection__panel--active');
    });

    // Add active class to selected tab and panel
    this.tabs[newIndex].classList.add('tab-collection__tab--active');
    this.panels[newIndex].classList.add('tab-collection__panel--active');
  }
}

// Initialize all tab collections on the page
document.addEventListener('DOMContentLoaded', () => {
  const tabCollections = document.querySelectorAll('.tab-collection');
  tabCollections.forEach((container) => {
    new TabCollection(container);
  });
});
